// extracted by mini-css-extract-plugin
module.exports = {"root":"Table_root__2exDV","inputWrap":"Table_inputWrap__2RoZ-","col":"Table_col__2ikat","bmiTooltip":"Table_bmiTooltip__1UIO2"};